import { useQuery } from "@tanstack/react-query";

import { listWorkers } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";
import type { Worker } from "../types";
import { toWorker } from "../utils/map";

export function useWorkers() {
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useQuery({
		queryKey: ["workers", activeCanteiroId],
		enabled: activeCanteiroId != null,
		queryFn: async (): Promise<Worker[]> => {
			const { items } = await listWorkers(activeCanteiroId as string);
			return items.map(toWorker);
		},
		staleTime: 30_000,
	});
}

export function activeWorkers(workers: Worker[] | undefined): Worker[] {
	return (workers ?? []).filter((worker) => worker.active);
}

export function inactiveWorkers(workers: Worker[] | undefined): Worker[] {
	return (workers ?? []).filter((worker) => !worker.active);
}
